import {
  AtlasBodyMain,
  AtlasCaption,
  CardComponent,
  NavigationMenuOrganism,
  PageContentAtom
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'

import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { useTokenType } from './TokenType.hook'

const TokenTypePage = () => {
  const { actions, user, country, warehouse, otpRoles } = useTokenType()

  return (
    <>
      <NavigationMenuOrganism
        title="Generar código"
        country={country}
        userEmail={user.username}
        userName={user.firstName}
        version="13.0.1"
        warehouseName={warehouse?.coreDescription || 'Pruebas'}
        onLogout={actions.logout}
        menuItems={user.menuItems || []}
      />

      <PageContentAtom>
        <StackAtom $gap={24} $direction="column">
          <InstructionsMolecule
            lines={['Selecciona el módulo del que necesitas el código.']}
          />

          {otpRoles.length > 0 && (
            <div
              style={{
                display: 'grid',
                gap: 16,
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, auto))',
                justifyContent: 'center'
              }}
            >
              {otpRoles.map((otpRole) => (
                <CardComponent
                  key={otpRole.id}
                  $variant="highlight"
                  style={{
                    maxWidth: 200,
                    width: '100%'
                  }}
                  onClick={() => {
                    actions.onSelectType(otpRole.id)
                  }}
                >
                  <StackAtom $gap={4} $align="center">
                    <Icon name={otpRole.iconName} color="#E0E0E0" size={18} />
                    <AtlasCaption>{otpRole.label}</AtlasCaption>
                  </StackAtom>
                </CardComponent>
              ))}
            </div>
          )}

          {!otpRoles.length && (
            <AtlasBodyMain>No tienes permiso para generar tokens</AtlasBodyMain>
          )}
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default TokenTypePage
